<div class="bg-mesh flex h-screen w-full flex-col items-center">
  <app-top-app-bar />

  <main class="flex w-full flex-grow flex-col items-center overflow-y-auto">
    @if (currentScreenComponent(); as screenComponent) {
      <ng-container *ngComponentOutlet="screenComponent" />
    } @else {
      <router-outlet />
    }
  </main>
</div>
